// extracted by mini-css-extract-plugin
export default {"root":"IconCreditCard_root__o2b0G"};